<template>
    <v-container>
        <v-card>
            <v-card-text>
                <JobBpeList 
                    ref="bpe"
                    :selectedCar="job.car"
                    :job="job" 
                    :branchCode="job.branchCode"
                    @edited="edited"
                    @onSelectBpe="onSelectBpe"
                >
                </JobBpeList>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

import JobBpeList from '../JobBpeList'

export default {
    name: 'Tab2',
    components: {
        JobBpeList
    },
    props: ["job", "pageCode"],
    methods: {
        edited() {
            this.$emit("edited", true);
        },
        onSelectBpe(items) {
            this.$emit("onSelectBpe", items)
        }
    },
    mounted() {
        if (!(this.pageCode == 'J01' || this.pageCode == 'J04')) {
            this.$refs.bpe.setCanEdit(false);
        } else {
            this.$refs.bpe.setCanEdit(parseInt(this.job.jobStatusCode) <= 10 && !this.job.deliveryDate);
        }
        
        this.$refs.bpe.setBpeItems(this.job.bpeList);
    }
}
</script>